export const OpportunitiesPanelsColumns=[
    {
        name: "N° do Painel",
        id: "number"
    },
    {
        name: "Nome do Painel",
        id: "name"
    },
    {
        name: "Resultado",
        id: "resultFormat"
    },
    {
        name: "Data de Criação",
        id: "dateFormat"
    },
    {
        name: "Ano",
        id: "year"
    }
];